/**
 * Running - 运行时命令监听与动作执行
 * 监听 core 的 commandQueues，执行对应 action（通过 moduleLoader 调用业务模块方法）
 */
import {
  getCoreConfig,
  useAndStore,
  useStoreByName,
} from "@nuwatop/code-canvas-core";

const currentModule = { module: "Module1" };
const router: { router: any } = { router: undefined };

export const useModule = (module: string) => {
  currentModule.module = module;
};

export const setRoute = (route: any) => {
  router.router = route;
};

const executeAction = (
  actionName: string,
  args: any,
  moduleLoader?: (moduleName: string) => Promise<any>
) => {
  if (moduleLoader) {
    moduleLoader(currentModule.module)
      .then((module) => {
        if (typeof module[actionName] === "function") {
          module[actionName](args);
        } else {
          console.error(
            `Action "${actionName}" does not exist on the module.`
          );
        }
      })
      .catch((err) => {
        console.error(`Failed to execute action:${actionName}`, err);
      });
  } else {
    console.warn(
      "Module loader not configured. Please provide moduleLoader in initRuntime options."
    );
  }
};

/**
 * 初始化运行时：监听 commands 变化并执行对应 action
 */
export const initRuntime = (options?: {
  sessionId?: string;
  utils?: any;
  moduleLoader?: (moduleName: string) => Promise<any>;
}) => {
  const { sessionId = "default", utils, moduleLoader } = options || {};
  const config = getCoreConfig();

  let prevQueueLength = 0;

  const unsubscribe = useAndStore.subscribe((state) => {
    const queue = state.commandQueues[sessionId] ?? [];
    if (queue.length <= prevQueueLength) {
      prevQueueLength = queue.length;
      return;
    }
    const cmd = queue[queue.length - 1];
    if (!cmd || typeof cmd.actionName !== "string") return;

    prevQueueLength = queue.length;
    useAndStore.getState().popCommand(sessionId);

    executeAction(
      cmd.actionName,
      {
        ...cmd.arg,
        moduleName: currentModule.module,
        ctx: {
          utils,
          useStoreByName,
          defHttp: config.request,
          useValidateWatchStore: undefined,
          router: router.router,
        },
      },
      moduleLoader
    );
  });

  return unsubscribe;
};
